import { DropDown } from '@elementary/common-ui/components';
import { ReactComponent as EyeHiddenIcon } from '@elementary/common-ui/assets/16x16/eye-hidden.svg';
import { ReactComponent as EyeIcon } from '@elementary/common-ui/assets/16x16/eye.svg';
import { ReactComponent as EditIcon } from '@elementary/common-ui/assets/16x16/edit-3.svg';
import { PermissionsAccess } from '../../shared/types';

const ENVIRONMENT_PERMISSION_OPTIONS = [
  { value: PermissionsAccess.HIDDEN, label: 'Hidden', icon: <EyeHiddenIcon /> },
  { value: PermissionsAccess.READ, label: 'Read-only', icon: <EyeIcon /> },
  { value: PermissionsAccess.WRITE, label: 'Editable', icon: <EditIcon /> },
];

const ALL_PERMISSION_OPTIONS = [
  ...ENVIRONMENT_PERMISSION_OPTIONS,
  { value: PermissionsAccess.CUSTOM, label: 'Custom' },
];

type Props = {
  value: PermissionsAccess;
  onChange: (value: PermissionsAccess) => void;
  includeCustom?: boolean;
  disabled?: boolean;
  className?: string;
};

const PermissionsAccessDropdown = ({
  value,
  onChange,
  includeCustom,
  disabled,
  className,
}: Props) => {
  const options = includeCustom
    ? ALL_PERMISSION_OPTIONS
    : ENVIRONMENT_PERMISSION_OPTIONS;

  const displayOptions =
    value === PermissionsAccess.CUSTOM && !includeCustom
      ? ALL_PERMISSION_OPTIONS
      : options;

  return (
    <DropDown
      className={className}
      options={displayOptions}
      value={value}
      onChange={onChange}
      menuWidth="145px"
      sortOptions={false}
      disabled={disabled}
    />
  );
};

export default PermissionsAccessDropdown;
